export default __webpack_public_path__ + "static/media/rest2.5e483123.jpg";